import { style } from '@vanilla-extract/css';

import { blockquoteFigure } from './BlockquoteFigure.css';

export const quoteContent = style({});

export const quote = style({
  selectors: {
    [`${blockquoteFigure['1']} &`]: {
      textAlign: 'var(--wt-quote-alignment, left)',
      fontSize: 'var(--wt-quote-font-size)',
      fontFamily: 'var(--wt-quote-font-family)',
      color: 'var(--wt-quote-font-color)',
      fontWeight: 'var(--wt-quote-font-weight)',
      lineHeight: 'var(--wt-quote-line-height-exact)',
    },
    [`${blockquoteFigure['2']} &`]: {
      textAlign: 'var(--wt-quote-2-alignment, left)',
      fontSize: 'var(--wt-quote-2-font-size)',
      fontFamily: 'var(--wt-quote-2-font-family)',
      color: 'var(--wt-quote-2-font-color)',
      fontWeight: 'var(--wt-quote-2-font-weight)',
      lineHeight: 'var(--wt-quote-2-line-height-exact)',
    },
    [`${blockquoteFigure['3']} &`]: {
      textAlign: 'var(--wt-quote-3-alignment, center)',
      fontSize: 'var(--wt-quote-3-font-size)',
      fontFamily: 'var(--wt-quote-3-font-family)',
      color: 'var(--wt-quote-3-font-color)',
      fontWeight: 'var(--wt-quote-3-font-weight)',
      lineHeight: 'var(--wt-quote-3-line-height-exact)',
    },
  },
});

export const quoteMark = style({
  display: 'none',
  userSelect: 'none',
  WebkitUserSelect: 'none',
  MozUserSelect: 'none',
  msUserSelect: 'none',
  fontSize: 'var(--wt-quote-3-mark-font-size, 48px)',
  fontFamily: 'var(--wt-quote-3-mark-font-family, Arial)',
  color: 'var(--wt-quote-3-mark-color, #000000)',
  textAlign: 'var(--wt-quote-3-mark-alignment, center)',
  lineHeight: 1,
  marginBottom: 'var(--wt-quote-3-mark-spacing, 12px)',
  selectors: {
    [`${blockquoteFigure['3']} ${quote} > &`]: {
      display: 'block',
    },
  },
});
